// One button look across the HUD, lobby, pause menu and cards (#225's
// design system, `theme.ts`): flat palette fills (`index.css`), a hard ink
// edge with a drop shadow that presses in, heavy italic capitals. Add
// sizing (padding, text, width) where the button is used.

const INK =
  "rounded-md border-2 border-ink text-center font-black uppercase italic tracking-wide shadow-[0_3px_0_var(--color-ink)] transition-transform active:translate-y-0.5 active:shadow-none focus-visible:outline-3 focus-visible:outline-offset-2 focus-visible:outline-focus";

/** The one thing to do next: the accent fill. */
export const PRIMARY = `${INK} bg-accent text-on-accent hover:bg-accent-soft`;

/** Everything else on a panel: the panel's own row colour. */
export const SECONDARY = `${INK} bg-surface-soft text-on-surface hover:bg-line`;

/** A quiet text button over the park (the lobby's footer links): a dark pill frames its text. */
export const GHOST =
  "rounded-md bg-ink/60 px-3 py-1.5 text-center text-sm font-black uppercase italic tracking-wide text-white hover:bg-ink/80 focus-visible:outline-3 focus-visible:outline-white";

/** A round icon button over the park: a 44 px tap target. Give it an `aria-label`. */
export const ICON =
  "pointer-events-auto grid size-11 shrink-0 place-items-center rounded-full border-2 border-ink bg-surface/90 text-center text-lg font-black leading-none text-on-surface shadow-[0_3px_0_var(--color-ink)] hover:bg-surface-soft focus-visible:outline-3 focus-visible:outline-focus";

/** An icon button whose menu is open: the accent fill. */
export const ICON_ON = ICON.replace("bg-surface/90 text-on-surface hover:bg-surface-soft", "bg-accent text-on-accent");
